// extracted by mini-css-extract-plugin
module.exports = {"warningBox":"SalesRestrictedReportWarning_warningBox__3mX5q"};